// extracted by mini-css-extract-plugin
export default {"confirmation":"information-verification-prompt_confirmation__U5hQv","container":"information-verification-prompt_container__OJJrd"};